import { ExternalLink, Lock, ShieldCheck, Wallet } from 'lucide-react';
import type { Address } from 'viem';

const BADGES = {
  nonCustodial: { icon: Wallet, label: '논커스터디얼' },
  principalSafe: { icon: Lock, label: '원금 상시 출금' },
  onchain: { icon: ShieldCheck, label: '온체인 검증' },
} as const;

// Reusable trust strip for the earn/farm/lending screens: surfaces the
// verifiable on-chain contract and a couple of reassurance badges so members
// can independently confirm how the product custodies funds.
export default function TrustBar({
  contract,
  badges = ['nonCustodial', 'onchain'],
  note,
}: {
  contract?: Address;
  badges?: (keyof typeof BADGES)[];
  note?: string;
}) {
  const scanUrl = contract ? `https://testnet.bscscan.com/address/${contract}` : undefined;

  return (
    <div className="rounded-xl border border-abyss-700 bg-abyss-850 p-4">
      <div className="flex flex-wrap items-center gap-2">
        {badges.map((b) => {
          const { icon: Icon, label } = BADGES[b];
          return (
            <span
              key={b}
              className="flex items-center gap-1.5 text-[11px] font-medium text-tide-400 bg-tide-400/10 px-2 py-1 rounded-md"
            >
              <Icon size={12} />
              {label}
            </span>
          );
        })}
        {scanUrl && (
          <a
            href={scanUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1.5 text-[11px] font-medium text-foam-300 hover:text-foam-100 bg-abyss-900/60 border border-abyss-700 px-2 py-1 rounded-md transition-colors ml-auto"
          >
            컨트랙트 {contract!.slice(0, 6)}…{contract!.slice(-4)}
            <ExternalLink size={11} />
          </a>
        )}
      </div>
      <p className="text-[11px] text-foam-500 leading-relaxed mt-2.5">
        {note ??
          '자금은 스마트 컨트랙트가 온체인에서 관리하며, 예치 원금은 언제든 직접 출금할 수 있습니다. 모든 거래는 회원 지갑에서 직접 서명해야 체결됩니다. (BSC 테스트넷)'}
      </p>
    </div>
  );
}
